import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import Dashboard from './components/dashboard/Dashboard';
import EventsPage from './components/events/EventsPage';
import { FirebaseProvider } from './components/firebase/FirebaseProvider';
import { AuthProvider } from './contexts/AuthContext';
import { ScoringProvider } from './contexts/ScoringContext';
import { LeadsProvider } from './contexts/LeadsContext';
import ProtectedRoute from './components/auth/ProtectedRoute';

/**
 * Renders both tabs simultaneously and toggles visibility with CSS.
 * This keeps both components mounted across tab switches so no state,
 * computations, or data fetches are repeated when the user switches tabs.
 */
const AppTabs: React.FC = () => {
  const { pathname } = useLocation();
  const isLeads = pathname === '/' || pathname === '';

  return (
    <>
      <div style={{ display: isLeads ? 'block' : 'none' }}>
        <Dashboard />
      </div>
      <div style={{ display: isLeads ? 'none' : 'block' }}>
        <EventsPage />
      </div>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <FirebaseProvider>
        <AuthProvider>
          <ScoringProvider>
            <ProtectedRoute>
              <LeadsProvider>
                <AppTabs />
              </LeadsProvider>
            </ProtectedRoute>
          </ScoringProvider>
        </AuthProvider>
      </FirebaseProvider>
    </BrowserRouter>
  );
}

export default App;
